import { render } from "./OtherMeetingVideos.vue?vue&type=template&id=98cbee0a"
import script from "./OtherMeetingVideos.vue?vue&type=script&lang=js"
export * from "./OtherMeetingVideos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__